import React from "react";
import { Typography } from "../../../../components";
import { OnlyFansAccount } from "../../../../api/staff";

interface OrdersCellProps {
  account: OnlyFansAccount;
}
const getCampaignsText = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return 'заказов';
  }

  if (lastDigit === 1) {
    return 'заказ';
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'заказа';
  }

  return 'заказов';
};


const OrdersCell: React.FC<OrdersCellProps> = ({ account }) => {
  const ordersInProgress = account?.orders_stats?.in_progress ?? account?.orders_in_progress_count ?? 0;
  const totalOrders = account?.orders_stats?.total ?? account?.orders_count ?? 0;

  return (
    <div className="flex items-center gap-[4px]">
      <Typography variant="body3" className="!text-[#006FEE] text-[12px] font-regular leading-[18px]">
        {ordersInProgress}
      </Typography>
      <Typography variant="body3" className="!text-[#D4D4D8] text-[12px] font-regular leading-[18px]">
        •
      </Typography>
      <Typography variant="body3" className="!text-[#71717A] text-[12px] font-regular leading-[18px]">
        {totalOrders} {getCampaignsText(totalOrders)}
      </Typography>
    </div>
  );
};

export default OrdersCell;
